export default __webpack_public_path__ + "assets/images/b1ba4d2ae78ab957c63a20dc05f45d3c.png";